<template>
  <section class="min-h-screen">
    <Transition name="fade">
      <div
        v-show="showUserForm"
        class="container mx-auto max-w-xl my-8 pb-8"
      >
        <hr class="divider divider--small">
        <div class="mt-4 text-center">
          <h1 v-text="'NEP Connect Account'" />
          <p class="text-sm">
            These are your global credentials used to sign in to <br>
            every organization you're a member of.
          </p>
        </div>
        <div class="flex flex-wrap mt-8 pt-8">
          <UserAvatar
            class="flex-1 justify-center mr-8"
            :avatar="avatar"
            @avatarUploaded="(url) => avatar = url"
          />
          <ProfileDetails
            class="m-4 mt-8 md:m-0 flex-1 flex-col"
            :security-questions="securityQuestions"
            :show-testing-helpers="showTestingHelpers"
            @showUserForm="showUserForm = true"
            @setInitialAvatar="(url) => avatar = url"
          />
        </div>
      </div>
    </Transition>
    <Transition name="fade">
      <div
        v-show="showMemberships"
        class="bg-grey-darker"
      >
        <div class="container mx-auto max-w-xl">
          <MembershipList
            class="mb-8 pt-2 pb-8 mt-8"
            :organization-uuid="organizationUuid"
            @membershipsLoaded="showMemberships = true"
          />
        </div>
      </div>
    </Transition>
  </section>
</template>

<script type="text/babel">
import MembershipList from 'Membership/Resources/assets/js/components/profiles/MembershipList'
import UserAvatar from './UserAvatar'
import ProfileDetails from './ProfileDetails'

export default {
  name: 'UserProfile',
  components: {
    ProfileDetails,
    UserAvatar,
    MembershipList,
  },
  props: {
    organizationUuid: {
      type: [Boolean, String],
      required: false,
      default: false,
    },
    securityQuestions: {
      type: Array,
      required: false,
      default: () => [],
    },
    showTestingHelpers: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      showUserForm: false,
      showMemberships: false,
      avatar: '',
    }
  },
}
</script>
